// 문항 첨부칸(DFFile_URL2·DFAttachedFileURL·DFAttachedFileURLSub)과 첨부 보관함(AttachmentsStorage)이 같이 쓰는 첨부 규칙.
// 허용 형식은 한 곳에서만 정한다 — .xls 는 불허, 엑셀은 .xlsx 만 (2026-10-16 사용자 결정).
const ALLOWED_EXTENSIONS = [
    'txt', 'md', 'json', 'xml', 'csv',
    'pdf', 'docx',
    'xlsx',
    'pptx',
    'png', 'jpg', 'jpeg', 'gif'
];
const MAX_FILE_SIZE_MB = 30;
const MAX_FILES_COUNT = 20;

// 증빙 링크는 http(s) 만 받는다 (javascript:·mailto:·file: 는 거절)
const urlRegex = new RegExp(
    '^(https?:\\/\\/)' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // 도메인 이름
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // 또는 IP 주소
    '(\\:\\d+)?(\\/[^\\s<>"{}|\\\\^`\\[\\]]*)*' + // 포트 번호 및 경로 (URL 인코딩된 문자 포함)
    '(\\?[^\\s<>"{}|\\\\^`\\[\\]#]*)?' + // 쿼리 파라미터
    '(\\#[^\\s<>"{}|\\\\^`\\[\\]]*)?$', // 해시 / 프래그먼트
    'i'
);

function isValidURL(url) {
    if (typeof url !== 'string' || url.trim() === '') {
        return false;
    }
    return urlRegex.test(url);
}

// 업로드 목록에 넣으면 안 되는 이유($t 키)를 돌려준다. 통과면 null. pending 은 이미 업로드 목록에 있는 파일들
function fileRejectReason(file, pending = []) {
    if (!file.name.includes('.')) return '파일 확장자가 없습니다.';
    if (!ALLOWED_EXTENSIONS.includes(file.name.split('.').pop().toLowerCase())) return '허용하지 않는 파일 형식입니다.';
    if (file.size === 0) return '빈 파일입니다.';
    if (file.size > 1024 * 1024 * MAX_FILE_SIZE_MB) return '파일 크기가 30MB를 초과합니다.';
    if (pending.some(({name, size}) => name === file.name && size === file.size)) return '이미 업로드 목록에 존재하는 파일입니다.';
    return null;
}

// 고른 파일 중 올릴 수 있는 것만 돌려준다. 개수 초과면 아무것도 넣지 않고, 거절된 파일은 파일별 사유를 모달로 알린다.
function pickUploadableFiles(vm, files, pending = []) {
    if (files.length > MAX_FILES_COUNT) {
        vm.$showModal({
            type: 'alert',
            state: 'warning',
            title: vm.$t('최대 업로드 파일 개수 초과'),
            message: vm.$t('한 번에 업로드할 수 있는 파일은 최대 {count}개 입니다.', {count: MAX_FILES_COUNT})
        });
        return [];
    }

    const accepted = [];
    const rejected = [];
    files.forEach(file => {
        const reason = fileRejectReason(file, [...pending, ...accepted]);
        if (reason) rejected.push({name: file.name, reason: vm.$t(reason)});
        else if (pending.length + accepted.length >= MAX_FILES_COUNT) {
            rejected.push({name: file.name, reason: vm.$t('한 번에 업로드할 수 있는 파일은 최대 {count}개 입니다.', {count: MAX_FILES_COUNT})});
        } else accepted.push(file);
    });

    if (rejected.length) {
        const h = vm.$createElement;
        vm.$showModal({
            type: 'alert',
            state: 'warning',
            title: vm.$t('조건에 맞지 않는 파일은 제외되었습니다.'),
            message: h('div', [
                h('ul', rejected.map(file => h('li', `${file.name} : ${file.reason}`)))
            ])
        });
    }
    return accepted;
}

export {isValidURL, fileRejectReason, pickUploadableFiles, ALLOWED_EXTENSIONS, MAX_FILE_SIZE_MB, MAX_FILES_COUNT};
